import React from 'react';
import { Droplets, Crown, ArrowRight } from 'lucide-react';

interface WatermarkWarningProps {
  onUpgrade: () => void;
  className?: string;
}

const WatermarkWarning: React.FC<WatermarkWarningProps> = ({ onUpgrade, className = '' }) => {
  return (
    <div className={`bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200 rounded-xl p-4 ${className}`}>
      <div className="flex items-start space-x-3">
        <div className="w-8 h-8 bg-gray-100 text-gray-600 rounded-full flex items-center justify-center flex-shrink-0">
          <Droplets className="w-4 h-4" />
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="font-semibold text-gray-900 mb-1">Clips will include watermarks</h4>
              <p className="text-sm text-gray-600">
                Remove watermarks and unlock professional features with Creator Pro
              </p>
            </div>
            <button
              onClick={onUpgrade}
              className="flex items-center space-x-2 bg-red-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-red-700 transition-colors text-sm"
            >
              <Crown className="w-4 h-4" />
              <span>Upgrade</span>
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WatermarkWarning; 